export type Author = {
  name: string;
  avatarUrl?: string;
  twitterHandle?: string;
  jobTitle?: string;
};

export type PostMetadata = {
  slug: string;
  title: string;
  description: string;
  authors?: Author[];
  date: string;
  length: string;
  category: string;
  published: boolean;
  image: any;
  contentOverride?: string;
  githubLink?: string;
};

export function getImageUrl(id: string): string {
  return `https://modal-cdn.com/blog/images/${id}.webp`;
}

const slugFromPath = (path: string) =>
  path.match(/([\w-]+)\.(svelte\.md|md|svx)/i)?.[1] ?? null;

export async function getPublishedPosts(): Promise<PostMetadata[]> {
  const modules = import.meta.glob(`../../../lib/blog/*.svx`);
  const validCategories = [
    "Engineering",
    "Customer Stories",
    "Tutorials",
    "News",
    "Technology",
  ];

  const postPromises = Object.entries(modules).map(([path, resolver]) =>
    resolver().then(async (post) => {
      const slug = slugFromPath(path)!;
      return {
        slug,
        image: getImageUrl(slug),
        ...(post as any).metadata,
      };
    }),
  );

  const posts = await Promise.all(postPromises);
  const publishedPosts = posts.filter(
    (post) => post.published && validCategories.includes(post.category),
  );
  publishedPosts.sort((a, b) => (new Date(a.date) > new Date(b.date) ? -1 : 1));
  return publishedPosts;
}
